import React from 'react';
import { getSelectOptions } from '../../../../../common/src/domain/customInspectionTypes/amsterdamOverspanningen/inspectieOverspanningen';
import { ISurvey } from '../../../components/Surveys/Interfaces/ISurvey';
import { ISurveyTemplateElementGroupData } from '../../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { fetchJson } from '../../../store/fetch';
import { ICustomInspectionTypeFrontEndSettings } from '../../ICustomInspectionTypeFrontEndSettings';
import { SurveyDetailsAoInspectieOverspanningen } from './SurveyDetailsAoInspectieOverspanningen';
import { SurveyEditAoInspectieOverspanningenDecomposition } from './SurveyEditAoInspectieOverspanningenDecomposition';

const tabNames = {
    summaryAndAdvice: 'summaryAndAdvice',
    decomposition: 'decomposition',
};

function Nothing(): JSX.Element | null {
    return null;
}

function SurveyEditPage(
    props: { tabName: string; surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    switch (props.tabName) {
        case tabNames.decomposition:
            return <SurveyEditAoInspectieOverspanningenDecomposition {...props} />;
        case tabNames.summaryAndAdvice:
            return null;
        default:
            return <h1>Unknown tab &quot;${props.tabName}&quot;</h1>;
    }
}
function SurveyDetailsComponents(props: { survey: Required<ISurvey> }) {
    return (
        <>
            <SurveyDetailsAoInspectieOverspanningen surveyId={props.survey.id} />
        </>
    );
}

export const aoInspectieOverspanningenFrontEndSettings: ICustomInspectionTypeFrontEndSettings = {
    tabNames,

    surveyEditTabs: [
        { name: tabNames.decomposition, text: 'Decompositie' },
        { name: tabNames.summaryAndAdvice, textTranslateKey: 'survey.summaryAndAdviceTab' },
    ],
    surveyEditDefaultTabName: tabNames.decomposition,
    objectTreeDefaults: { filterOnElementGroups: false },
    objectTreeOptions: { archiveLinkAvailable: false, hasElementsGroups: false },
    showDocuments: false,

    getSurveyDetailsLeftTrayListItems: Nothing,
    getSurveyDetailsScrollMenuItems: Nothing,
    getSurveyEditSummaryAndAdvice: Nothing,
    getDecompositionElementAddEdit: Nothing,
    getDecompositionUnitAddEdit: Nothing,
    getSurveyEditPage: SurveyEditPage,
    getSurveyDetailsComponents: SurveyDetailsComponents,

    showObjectTree: (tabName: string) => [tabNames.decomposition].includes(tabName),
    surveyEditLoadElements: async (surveyId: string) => {
        const elementsResponse = await fetchJson(
            `/api/surveys/${surveyId}/elements/amsterdamOverspanningen/inspectieOverspanningen/objectTree`,
            'GET',
        );
        const elements = elementsResponse.json;
        return {
            elements,
        };
    },
    showLabelInSurveysMap: false,
    getSurveyConditionFilterOptions: getSelectOptions,
};
